import { ThemeProvider } from "@repo/ui/provider";
import { Route, Routes } from "react-router";
import LandingLayout from "./components/LandingLayout";
import AndroidBuilds from "./pages/AndroidBuilds";
import Contact from "./pages/Contact";
import Developers from "./pages/Developers";
import Emulators from "./pages/Emulators";
import EngineeringLeaders from "./pages/EngineeringLeaders";
import Feedback from "./pages/Feedback";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Platform from "./pages/Platform";
import RemoteDev from "./pages/RemoteDev";
import Testing from "./pages/Testing";

function App() {
  return (
    <ThemeProvider forceColorScheme="dark">
      <Routes>
        <Route element={<LandingLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/platform" element={<Platform />} />
          <Route path="/products/android-builds" element={<AndroidBuilds />} />
          <Route path="/products/emulators" element={<Emulators />} />
          <Route path="/products/remote-dev" element={<RemoteDev />} />
          <Route path="/products/testing" element={<Testing />} />
          <Route path="/solutions/engineering-leaders" element={<EngineeringLeaders />} />
          <Route path="/solutions/developers" element={<Developers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mb/feedback" element={<Feedback />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App;
